import { h } from 'preact';
import cx from 'classnames';
import style from './style';
import LinkEvent from '../linkevent';
import Logo from '@cube/logo-widget';

export default function LogoIcon({ link, theme, size, class: cls, portalStaticOrigin }) {
	let logo = (
		<Logo
			class={cx(style.logo, cls)}
			theme={theme}
			size={size}
			link={false}
			portalStaticOrigin={portalStaticOrigin}
		/>
	);
	return (link && link.url) ? (
		<LinkEvent link={link}>
			{logo}
		</LinkEvent>
	) : logo;
}
